export const PRIMARY_NAV_ITEMS = [
  {
    label: "Accounts",
    to: "/dashboard",
  },
  {
    label: "Account Audits",
    to: "/account-audits",
    featureFlag: (plan) => plan.paid_media_enabled === true,
  },
  {
    label: "Organization",
    resolveTo: ({ selectedOrgId }) =>
      selectedOrgId ? `/organizations/${selectedOrgId}` : "/organizations/manage",
  },
  {
    label: "Admin",
    roles: ["admin"],
    children: [
      {
        label: "Admin Home",
        to: "/admin",
        roles: ["admin"],
      },
      {
        label: "Tag Reference",
        to: "/admin/tag-reference",
        roles: ["admin"],
      },
      {
        label: "Product Event Owners",
        to: "/admin/product-event-owners",
        roles: ["admin"],
      },
      {
        label: "UI Library",
        to: "/ui-library",
        roles: ["admin"],
      },
      {
        label: "Theme Library",
        to: "/theme-library",
        roles: ["admin"],
      },
    ],
  },
]
